import { z } from 'zod'

export const errorResponseSchema = z.object({
  code: z.string(),
  msg: z.string(),
})

export const successResponseSchema = z.object({
  code: z.literal('200000'),
})

export const responseDataSchema = z.object({
  currentPage: z.number().int(),
  pageSize: z.number().int(),
  totalNum: z.number().int(),
  totalPage: z.number().int(),
})
